// Dependencies
require("webstrap/type");

// Styles
require("./information-small.scss");


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/element/information-small/index.js
 ** module id = 152
 ** module chunks = 0 1
 **/